/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'ai-mate.agent-header-banner-label': 'Agentbanner',
  'ai-mate.agent-list.all-agents-section-title': 'Alle agents',
  'ai-mate.agent-list.beta-lozenge-title': 'Bèta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Je hebt de eigenaar gewijzigd van {agentName} naar {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'De eigenaar is veranderd',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Weet je zeker dat je deze Agent wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  'ai-mate.agent-list.delete-agent-confirm-title': "''{agentName}' verwijderen?",
  'ai-mate.agent-list.delete-agent-error': 'Kon de Agent niet verwijderen',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Er is iets misgegaan bij het verwijderen van de Agent. Probeer het over enkele ogenblikken opnieuw.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Kon agent niet verwijderen',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agent wordt momenteel gebruikt. Probeer het later opnieuw.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'We konden die Agent niet vinden.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Je kunt geen Agents verwijderen die je niet zelf hebt aangemaakt. Neem contact op met de Agenteigenaar.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Je hebt {agentName} verwijderd',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agent verwijderd',
  'ai-mate.agent-list.development-section-title': 'Ontwikkelingsagents',
  'ai-mate.agent-list.load-more-button-loading': 'Meer agents laden ...',
  'ai-mate.agent-list.load-more-button-ready': 'Meer laden',
  'ai-mate.agent-list.loading-agents': 'Agents laden ...',
  'ai-mate.agent-list.no-results': 'Geen resultaat gevonden voor {searchValue}',
  'ai-mate.agent-list.recommended-agents-section-title': 'Aanbevolen',
  'ai-mate.agent-list.searching-agents': 'Zoeken naar agents ...',
  'ai-mate.agent-list.templates-description':
    "Gebruik deze sjablonen om je eigen Ontwikkelaarsagent aan te maken. Kies de juiste Agentsjabloon voor je werk, selecteer Sjabloon gebruiken en vul vervolgens specifieke gegevens in de prompt van de sjabloon in, zoals de repository, map, taal en bibliotheek. Maak op maat gemaakte Ontwikkelaarsagents aan voor het coderen van verschillende taken, projecten en repository's.",
  'ai-mate.agent-list.templates-lozenge-title': 'Sjabloon',
  'ai-mate.agent-list.templates-title': 'Codesjablonen',
  'ai-mate.agent-message.agent-not-found': 'Agent niet gevonden',
  'ai-mate.agent-message.convo-title': 'Chat met {agentName} getriggerd door de insluiting van een Smart Link',
  'ai-mate.agent-message.copy-link': 'Agentlink kopiëren',
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Typ een bericht aan {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Verzenden',
  'ai-mate.agent-message.view-profile': 'Profiel bekijken',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Annuleren',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Verwijderen',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Chatten met {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL is gekopieerd',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Link kopiëren',
  'ai-mate.agent-profile-info.hidden-icon': 'Verborgen',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Agent wordt niet weergegeven in de zoekresultaten',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Agent een ster geven',
  'ai-mate.agent-selector.agent-not-found': 'Agent niet gevonden',
  'ai-mate.agent-selector.default-agent-description':
    'Krijg antwoorden, genereer nieuwe ideeën en versnel het dagelijkse werk.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Agentweergave sluiten',
  'ai-mate.profile-card-preview.actions-title': 'Acties',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Omschrijving',
  'ai-mate.profile-card-preview.agent-title-label': 'Titel',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Het gesprek beginnen',
  'ai-mate.profile-card-preview.empty-actions': 'Geen',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Geen',
  'ai-mate.profile-card-preview.empty-instructions': 'Geen',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Geen geselecteerd',
  'ai-mate.profile-card-preview.instructions-title': 'Instructies',
  'ai-mate.profile-card-preview.knowledge-title': 'Kennis',
  'ai-mate.profile-card-preview.regenerate-label': '{fieldName} opnieuw genereren',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - Kopie',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Sleep om te herschikken',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Kon wijzigingen niet opslaan',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Er is een onbekende fout opgetreden. Probeer het opnieuw',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Er bestaat al een agent met deze naam',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Verwijderen',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': 'Gespreksstarters genereren',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} mag niet langer dan {maxLength,number} teken zijn} other {{fieldName} mag niet langer dan {maxLength,number} tekens zijn}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Volgende',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Herstarten',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label':
    'Verdergaan naar handmatige configuratie',
  'create-agent.owner-field.confirm-modal-cancel': 'Annuleren',
  'create-agent.owner-field.confirm-modal-confirm': 'Ja, doorgaan',
  'create-agent.owner-field.confirm-modal-content':
    'Je staat op het punt om de eigenaar van deze agent te wijzigen naar {name}. Als je dit doet, kun je deze agent niet meer bewerken of beheren.',
  'create-agent.owner-field.confirm-modal-title': 'Je staat op het punt om bewerktoegang te verliezen',
  'create-agent.owner-field.owner-description': 'Dit is de persoon die de agent kan bewerken of beheren.',
  'create-agent.owner-field.owner-label': 'Eigenaar',
  'rovo-chat.agent-card.deactivated-name': '{name} (gedeactiveerd)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Te veel aanvragen. Wacht een moment.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Opnieuw proberen',
  'rovo-chat.browse-agents.all-agents-button': 'Alle',
  'rovo-chat.browse-agents.close-button': 'Sluiten',
  'rovo-chat.browse-agents.create-agent-button': 'Aanmaken',
  'rovo-chat.browse-agents.create-an-agent-button': 'Agent aanmaken',
  'rovo-chat.browse-agents.created-by-label': '<text>door</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Codeeragents',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favorieten',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agent toegevoegd aan favorieten',
  'rovo-chat.browse-agents.modal-title': 'Agents zoeken',
  'rovo-chat.browse-agents.my-agents-button': 'Mijn agents',
  'rovo-chat.browse-agents.no-created-agents':
    'Het lijkt erop dat je nog geen agents aangemaakt hebt. Begin met het dupliceren van andere bestaande agents of begin helemaal opnieuw om er een aan te maken.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Nog geen agents aangemaakt',
  'rovo-chat.browse-agents.no-starred-agents':
    'Als je een favoriete Agent hebt of een Agent die je vaak gebruikt, markeer die dan met een ster zodat je deze gemakkelijk kunt vinden.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Je hebt nog geen Agent met ster gemarkeerd.',
  'rovo-chat.browse-agents.search-input.placeholder': 'Agents zoeken',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Sjablonen zoeken',
  'rovo-chat.browse-agents.see-all-agents-button': 'Alle Agents bekijken',
  'rovo-chat.browse-agents.templates-button': 'Sjablonen',
  'rovo-chat.create-agent.actions-section-description':
    'Voeg acties toe voor je agent om taken uit te voeren in Jira, Confluence en Jira Service Management. <link>Wat zijn acties van agents?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Acties toevoegen',
  'rovo-chat.create-agent.all-content-label': 'Alle inhoud',
  'rovo-chat.create-agent.back-button': 'Ga terug',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Je hebt je Agent nog niet aangemaakt, wil je de agent wissen?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Annuleren',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Ja, Agent wissen',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Onvoltooide Agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Weet je zeker dat je de wijzigingen die je hebt aangebracht in deze Agent wilt verwijderen?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Bevestigen',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Aanmaken herstarten',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Mensen kunnen deze gebruiken om een gesprek te beginnen met je agent. Als je er geen kunt bedenken, kunnen we ze voor je genereren.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Het gesprek beginnen',
  'rovo-chat.create-agent.create-agent-button': 'Aanmaken',
  'rovo-chat.create-agent.ctions-section-title': 'Acties',
  'rovo-chat.create-agent.description-field-description':
    'Mensen kunnen de omschrijving op het profiel van de agent gebruiken om er meer over te weten te komen.',
  'rovo-chat.create-agent.description-field-label': 'Omschrijving',
  'rovo-chat.create-agent.description-field-placeholder':
    'Schrijf een korte omschrijving van je agent (bijvoorbeeld, creatief schrijver voor marketingblogs)',
  'rovo-chat.create-agent.instructions-field-description':
    'Hoe wil je dat deze agent zich gedraagt? Wat kan het doen? <link>Meer informatie over het schrijven van instructies voor een agent</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instructies',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Pas de instructies voor deze agent aan',
  'rovo-chat.create-agent.intro-description-part-1':
    'Stel een Agent samen die gespecialiseerde kennis bezit om vragen te beantwoorden, inhoud te schrijven en te beoordelen en taken uit te voeren waardoor jij werk gedaan kunt krijgen.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Als je hierbij geen hulp nodig hebt, kun je <bold>Verdergaan naar handmatige configuratie.</bold>',
  'rovo-chat.create-agent.intro-description-part-3':
    'Blijf op deze pagina als je wel wat hulp kunt gebruiken. Dan stellen we samen een Agent samen.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Ik stel instructies op voor de Agent op basis van wat jij schrijft. Laat me weten waarvoor je de Agent wilt gaan gebruiken.',
  'rovo-chat.create-agent.intro-step-1-title': 'Omschrijf wat je Agent moet kunnen',
  'rovo-chat.create-agent.intro-step-2-content':
    'Laten we samen bepalen hoe je Agent gaat heten en wat zijn persoonlijkheid is. Is je Agent empathisch, direct of juist heel grappig?',
  'rovo-chat.create-agent.intro-step-2-title': 'Geef je Agent een persoonlijkheid',
  'rovo-chat.create-agent.intro-step-3-content':
    'Klik op <bold>Volgende</bold> om je nieuwe Agent te bekijken en om acties, kennis en een profielfoto toe te voegen. Als je helemaal klaar bent, druk je op <bold>Aanmaken.</bold>',
  'rovo-chat.create-agent.intro-step-3-title': 'Bekijk je Agent en maak deze aan',
  'rovo-chat.create-agent.intro-title': '👋 We gaan je Agent aanmaken',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Alle projecten',
  'rovo-chat.create-agent.knowledge-field-description':
    'Specificeer de kennis van de agent door deze alleen toestemming te geven om naar bronnen te verwijzen die jij verstrekt',
  'rovo-chat.create-agent.knowledge-field-label': 'Kennis',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Alleen naar deze bronnen verwijzen',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Links',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Voorgesteld',
  'rovo-chat.create-agent.manage-actions-button-label': 'Acties beheren',
  'rovo-chat.create-agent.name-field-description': 'Mensen kunnen dit gebruiken om de agent te vinden.',
  'rovo-chat.create-agent.name-field-label': 'Naam',
  'rovo-chat.create-agent.name-field-placeholder': 'Geef je Agent een naam',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'Er is een onverwachte fout opgetreden. Probeer het opnieuw.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Hallo! Ik ben er om je te helpen een aanpasbare agent samen te stellen. Wat moet je agent doen?',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Een agent aanmaken',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Typ je bericht',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Verzenden',
  'rovo-chat.create-agent.page-title': 'Agent aanmaken',
  'rovo-chat.create-agent.page-title-edit': 'Agent bewerken',
  'rovo-chat.create-agent.search-for-pages-placeholder': "Pagina's zoeken",
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Spaces zoeken',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Alle',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Bèta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Annuleren',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Sluiten',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Als je minder dan {count,number} actie selecteert, krijg je optimale prestaties} other {Als je minder dan {count,number} acties selecteert, krijg je optimale prestaties}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Opslaan',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Acties zoeken',
  'rovo-chat.create-agent.select-action-modal-title': 'Acties toevoegen',
  'rovo-chat.create-agent.select-content-under-label': 'Selecteer inhoud onder',
  'rovo-chat.create-agent.select-spaces-label': 'Spaces selecteren',
  'rovo-chat.create-agent.selected-actions-label': 'Geselecteerde acties:',
  'rovo-chat.create-agent.unknown-owner': 'Onbekend',
  'rovo-chat.create-agent.update-agent-button': 'Bijwerken',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Als je doorgaat, gaan je niet-opgeslagen wijzigingen verloren. Selecteer Annuleren om door te gaan met het bewerken van deze Agent.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Doorgaan, wijzigingen ongedaan maken',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Wijzigingen ongedaan maken',
  'rovo-chat.view-agent.about-label': 'Over',
  'rovo-chat.view-agent.actions-label': 'Acties',
  'rovo-chat.view-agent.all-knowledge-added': 'Alle organisatiekennis',
  'rovo-chat.view-agent.beta-label': 'Bèta',
  'rovo-chat.view-agent.beta-tag': 'Bèta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chatten met een Agent',
  'rovo-chat.view-agent.close-button': 'Sluiten',
  'rovo-chat.view-agent.copy-instructions-label': 'Kopiëren',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Kopieer instructies',
  'rovo-chat.view-agent.created-by-label': '<text>door</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Aantal favorieten',
  'rovo-chat.view-agent.go-back-label': 'Ga terug',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Forge-agents die met code zijn gebouwd, hebben verborgen instructies voor hun privacy.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Deze instructies zijn privé',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Forge-agents die met code zijn gebouwd, gebruiken geen normale kennisbronnen',
  'rovo-chat.view-agent.instructions-label': 'Instructies',
  'rovo-chat.view-agent.knowledge-label': 'Kennis',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} lid} other {{count,number} leden}}',
  'rovo-chat.view-agent.modal-title': 'Agents zoeken',
  'rovo-chat.view-agent.no-actions': 'Geen handelingen',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Deze agent heeft geen aangepaste instructies',
  'rovo-chat.view-agent.no-knowledge-added': 'Geen organisatiekennis',
  'rovo-chat.view-agent.no-teams': 'Geen onderdeel van een team',
  'rovo-chat.view-agent.open-chat-label': 'Open chat',
  'rovo-chat.view-agent.reactions-metadata-label': 'Aantal reacties',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo-agent',
  'rovo-chat.view-agent.teams-label': 'Teams',
  'rovo-chat.view-agent.users-metadata-label': 'Aantal gebruikers',
};
